
import { Request } from '../../../../index'
import { ParamsPUT } from 'app/common/types/food/schools/complexes/sort'


type ComplexesItemApi = {
  id: number
  position: number
}

type ParamsAPI = {
  complexes: Array<ComplexesItemApi>
}

type UrlParams = {
  id: number | string,
}

export const convertParams = (params: ParamsPUT): [ParamsAPI, UrlParams] => {
  const complexes = params.complexes.map((item, index) => {
    const { id } = item
    return { id, position: index }
  })
  return ([{ complexes }, { id: params.orgId }])
}

export const convertResult = (result: string) => {
  return result === 'success'
}

export const PUT_COMPLEXES_SORT: Request<ParamsPUT, ParamsAPI, UrlParams> = [
  'food/schools/{id}/complexes/sort',
  'put',
  ['data', 'result'],
]
